import { getKey } from './common';
import CONSTANT, { CACHE, EVENTS } from './constants';
import { TOKEN, FLOW } from '../../../common/src/constant';

import { postInWindow, openWindowPopup } from './formPost';
import { log } from '../common/logger';
import { initiateCheckout } from './deferred-utils';

function updateOrderIdInMiddleWare(cache, orderId) {
  cache.getData(CACHE.API).middleware.add(currentOptions => {
    const options = { ...currentOptions };
    getKey(options, 'data.body', {}).orderId = orderId;
    getKey(options, 'query', {}).orderId = orderId;
    return options;
  });
}

export const getValidTokenForFlow = cache => {
  return new Promise((resolve, reject) => {
    const config = cache.getData(CACHE.MERCHANT_CONFIG);
    const tokenData = cache.getData(CACHE.TOKEN_DATA);
    const txnAmount = cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT);
    const payableAmount = cache.getData(CONSTANT.TXN_AMOUNT);
    const emiSubventionToken = cache.getData(CONSTANT.EMISUBVENTION_TOKEN);
    const offer = cache.getData(CONSTANT.PAYMODE_BASED_OFFER);
    if (tokenData.tokenType === TOKEN.ACCESS) {
      log({
        eventType: EVENTS.ACCESS_TOKEN_INITIATE_TXN
      });
      const merchantConfig = cache.getData(CACHE.MERCHANT_CONFIG);
      const initiateTxnHandler = getKey(merchantConfig, 'handler.initiateTransaction', undefined);
      const notifyMerchant = getKey(
        cache.getData(CACHE.MERCHANT_CONFIG),
        'handler.notifyMerchant',
        undefined
      );
      if (typeof initiateTxnHandler === 'function') {
        const response = initiateTxnHandler(emiSubventionToken, payableAmount, txnAmount, offer);
        if (response && response.then) {
          // returned promise from the user intiatetxnHandler
          response.then(data => {
            cache.setData(CACHE.TOKEN_DATA, { token: data.token, tokenType: TOKEN.TXN });
            const config = cache.getData(CACHE.MERCHANT_CONFIG);
            if (config.data) {
              config.data.orderId = data.orderId;
            }
            cache.setData(CACHE.MERCHANT_CONFIG, config);
            resolve(data);
          });
        } else if (typeof response === 'object') {
          // returned string from the intiatetxnHandler
          cache.setData(CACHE.TOKEN_DATA, { token: response.token, tokenType: TOKEN.TXN });
          const config = cache.getData(CACHE.MERCHANT_CONFIG);
          if (config.data) {
            config.data.orderId = response.orderId;
          }
          cache.setData(CACHE.MERCHANT_CONFIG, config);
          resolve(response);
        } else {
          if (typeof notifyMerchant === 'function') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.HANDLER_ERROR, {
              message:
                'initiateTxnHandler should either return a promise or a object having orderId and token value'
            });
          }
          reject(response);
        }
      }
    } else if (config.flow === FLOW.DEFERRED) {
      // const initiateTxnHandler = getKey(config, 'handler.initiateTransaction', undefined);
      const emiPlans = cache.getData(CACHE.EMI_PLANS);
      const paymentIntent = cache.getData(CACHE.PAYMENT_INTENT);
      const obj = {
        payment_intent: paymentIntent
      };
      if (emiPlans) {
        obj.emi_plans = emiPlans;
      }
      initiateCheckout(obj)
        .then(data => {
          const token = getKey(data, 'token', null);
          const orderId = getKey(data, 'orderId', null);
          cache.setData(CACHE.TOKEN_DATA, { token, tokenType: TOKEN.TXN });
          cache.setData(CACHE.ORDER_ID, orderId.toString());
          const config = { ...cache.getData(CACHE.MERCHANT_CONFIG) };
          config.data.orderid = orderId;
          cache.setData(CACHE.MERCHANT_CONFIG, config);
          updateOrderIdInMiddleWare(cache, orderId);
          // this.callComponentSubmit();
          return resolve({ data });
        })
        .catch(err => {
          log({
            eventType: EVENTS.DEFERRED_INITIATE_TXN_ERROR,
            error: err
          });
          const notifyMerchant = getKey(
            cache.getData(CACHE.MERCHANT_CONFIG),
            'handler.notifyMerchant',
            undefined
          );

          postInWindow({}, cache, true); // close popup window as txn token api response failed
          if (notifyMerchant) {
            notifyMerchant(CONSTANT.HANDLER_ERROR, {
              message:
                'initiateTxnHandler should either return a promise or a object having orderId and token value'
            });
          }
          return reject(err);
        });
    } else {
      resolve();
    }
  });
};

export const customPay = (payCallback, cache, payload, shouldPopupOpen = true) => {
  shouldPopupOpen && openWindowPopup(cache);
  return new Promise((resolve, reject) => {
    getValidTokenForFlow(cache)
      .then(() => {
        payCallback(payload).then(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getAsyncPayload = (payload, cache, url) => {
  // if (url === API.PT) {
  openWindowPopup(cache);
  // }
  return new Promise((resolve, reject) => {
    getValidTokenForFlow(cache)
      .then(() => {
        resolve(payload(url));
      })
      .catch(err => {
        reject(err);
      });
  });
};



// WEBPACK FOOTER //
// ./utils/token.js